import { CommonActionType, GET_USA_WKT_SUCCESS } from '../Types/CommonActionTypes';

export interface ICommonReducerState {
  usaWKT: string;
}

export const commonReducerState: ICommonReducerState = {
    usaWKT: null
};

export const commonReducer = (
    state: ICommonReducerState = { ...commonReducerState },
    action: CommonActionType
): ICommonReducerState => {
    switch (action.type) {
        case GET_USA_WKT_SUCCESS: {
            return {
                ...state,
                usaWKT: action.data as string,
            };
        }
        
        default: {
            return state;
        }
    }
};
